import { z } from 'zod'

/**
 * `POST /l/{token}/verify` body (TO-454, ADR-0051). The visitor submits the
 * access `code` for a CODE-gated landing. Bounded to keep the verify cheap; the
 * value is compared (constant-time) against the offer's stored hash, never logged.
 */
export const landingVerifySchema = z.object({ code: z.string().min(1).max(256) }).strict()

export type LandingVerifyInput = z.infer<typeof landingVerifySchema>
